import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { ResultsSection } from './components/ResultsSection';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
export function App() {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-canvas font-sans text-ink selection:bg-accent-soft" data-id="element-0" data-mp="38k6vmr81ppkv">
      <noscript data-id="element-1" data-mp="3dmfqjt4hb1pm">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3diruam7ng177" />
      </noscript>

      <Hero data-id="element-3" data-mp="36hx792iaw2a" />
      <main data-id="element-4" data-mp="3688dot76uy6">
        <SocialProof data-id="element-5" data-mp="35ozsypftiwt" />
        <Testimonials data-id="element-6" data-mp="356rh3pi3e8j" />
        <ProblemSection data-id="element-7" data-mp="38kxqn1ac7l9" />
        <MethodSection data-id="element-8" data-mp="3uct0zcywiaxb" />
        <ResultsSection data-id="element-9" data-mp="3udkm1tuvgq9c" />
        <TomosSection data-id="element-10" data-mp="3uc9jtyh2rqkc" />
        <BonusesSection data-id="element-11" data-mp="3uevqzx020421" />
        <PricingSection data-id="element-12" data-mp="d4e4fpsbp6v4" />
        <ComparisonTable data-id="element-13" data-mp="d3mlbefwx1lq" />
        <GuaranteeSection data-id="element-14" data-mp="d45v27vesjoo" />
        <FAQSection data-id="element-15" data-mp="d2bf77yzvhrg" />
        <CostOfInaction data-id="element-16" data-mp="851kpdwr0fwr" />
        <FinalCTA data-id="element-17" data-mp="86mc4unrniqe" />
      </main>
      <Footer data-id="element-18" data-mp="83i3nl39q0tx" />
    </div>;
}